import {Inject, Injectable} from '@angular/core';
import {Headers, RequestOptions} from '@angular/http';
import {ActivatedRoute} from '@angular/router';
import {isPlatformBrowser, isPlatformServer} from '@angular/common';
import {PLATFORM_ID} from '@angular/core';
import {LocalStorageHelpers} from './localStorageHelpers';
import {HttpHeaders} from '@angular/common/http';


@Injectable()
export class SystemHelpers {

  static formatDateField(dateFiled) {
    return new Date(dateFiled['year'], dateFiled['month'] - 1, dateFiled['day']);
  }

  static preprocessFormSubmit(value: Object): Object {
    Object.keys(value).forEach(function (key) {
      if (value[key] === '') {
        value[key] = null;
      }
    });
    return value;
  }

  static facultyTrans(faculty_tag: string): string {
    const facultyTransArray = {
      'psychology': 'Psychology',
      'literature': 'Humanities',
      'economics': 'Economics',
      'medicine': 'Medicine',
      'political_science': 'Political Science',
      'law': 'Law',
      'engineering': 'Engineering',
      'sport_science': 'Sport Science',
      'architecture': 'Architecture',
      'science': 'Science',
      'gastronomy': 'Gastronomy',
      'seguridad_pública': 'Marketing'
    };
    if ( typeof facultyTransArray[faculty_tag] !== 'undefined'){
      return facultyTransArray[faculty_tag];
    }
    return  faculty_tag;
  }

  static clean(obj) {
    const propNames = Object.getOwnPropertyNames(obj);
    for (let i = 0; i < propNames.length; i++) {
      const propName = propNames[i];
      if (obj[propName] === null || obj[propName] === undefined || obj[propName] === '') {
        delete obj[propName];
      }
    }
    return obj;
  }
  constructor(@Inject(PLATFORM_ID) private platformId: Object,
              private localStorageHelpers: LocalStorageHelpers,
              private activatedRoute: ActivatedRoute) {
  }



  getCurrentLang(): string {
    if (isPlatformBrowser(this.platformId)) {
      let lang = navigator.language;
      if (typeof lang === 'undefined') {
        lang = 'en';
      } else if (lang === 'it-IT') {
        lang = 'it';
      } else if (lang !== 'it') {
        lang = 'en';
      }
      return lang;
    }
    if (isPlatformServer(this.platformId)) {
      return 'it';
    }
  }

  getCurrentLangUrl() {
    const routeParams = this.activatedRoute.snapshot.params;
  }

  public jwt() {
    // create authorization header with jwt token
    const currentUserToken = this.localStorageHelpers.get('token');
    if (currentUserToken) {
      const headers = new Headers({'Authorization': 'bearer ' + currentUserToken});
      return new RequestOptions({headers: headers});
    } else {
      return 'false';
    }
  }

  public jwt2() {
    // create authorization header with jwt token
    const currentUserToken = this.localStorageHelpers.get('token');
    const headers = new HttpHeaders({
      'Authorization': 'bearer ' + currentUserToken
    });
    return headers;
  }




}
